
import React from 'react';

// Common styles for layout components
const commonStyles = (style, isSelected) => ({
  ...style,
  outline: isSelected ? '2px solid #3b82f6' : '1px dashed transparent', // Show outline on selection or hover (can add hover later)
  outlineOffset: '-2px',
  transition: 'outline 0.2s ease',
  position: 'relative'
});

export const Section = ({ 
  node, 
  onSelect, 
  selectedId, 
  readOnly,
  renderChildren 
}) => {
  const isSelected = selectedId === node.id;
  
  const style = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: node.style?.padding || '20px',
    margin: node.style?.margin || '0',
    backgroundColor: node.style?.backgroundColor || 'transparent',
    backgroundImage: node.style?.backgroundImage ? `url(${node.style.backgroundImage})` : undefined,
    backgroundSize: node.style?.backgroundSize || 'cover',
    backgroundPosition: node.style?.backgroundPosition || 'center',
    minHeight: node.style?.minHeight || '50px',
    boxSizing: 'border-box',
    ...commonStyles(node.style, isSelected)
  };

  return (
    <div 
      className="report-section"
      style={style}
      onClick={(e) => {
        if (readOnly) return;
        e.stopPropagation();
        onSelect(node.id);
      }}
    >
      {/* Section Label (only visible when editing/selected usually, but helpful for structure) */}
      {isSelected && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          backgroundColor: '#3b82f6',
          color: 'white',
          fontSize: '10px',
          padding: '2px 6px',
          zIndex: 10
        }}>
          Section
        </div>
      )}
      
      {renderChildren(node.children)}
    </div>
  );
};

export const Row = ({ 
  node, 
  onSelect, 
  selectedId, 
  readOnly,
  renderChildren 
}) => {
  const isSelected = selectedId === node.id;
  
  const style = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
    minHeight: '30px',
    padding: node.style?.padding || '0',
    margin: node.style?.margin || '0',
    backgroundColor: node.style?.backgroundColor || 'transparent',
    gap: node.style?.gap || '0',
    boxSizing: 'border-box',
    ...commonStyles(node.style, isSelected)
  };

  return (
    <div 
      className="report-row"
      style={style}
      onClick={(e) => {
        if (readOnly) return;
        e.stopPropagation();
        onSelect(node.id);
      }}
    >
      {/* Row Label */}
      {isSelected && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          backgroundColor: '#10b981', // green for row
          color: 'white',
          fontSize: '10px',
          padding: '2px 6px',
          zIndex: 10
        }}>
          Row
        </div>
      )}

      {renderChildren(node.children)}
    </div>
  );
};

export const Column = ({ 
  node, 
  onSelect, 
  selectedId, 
  readOnly,
  renderChildren 
}) => {
  const isSelected = selectedId === node.id;
  
  const style = {
    display: 'flex',
    flexDirection: 'column',
    flex: node.style?.width ? `0 0 ${node.style.width}` : (node.style?.flex || 1), // Default to flex 1 if no width
    maxWidth: node.style?.width || '100%',
    minHeight: '30px',
    padding: node.style?.padding || '10px',
    margin: node.style?.margin || '0',
    backgroundColor: node.style?.backgroundColor || 'transparent',
    borderWidth: node.style?.borderWidth || '0',
    borderColor: node.style?.borderColor || 'transparent',
    borderStyle: node.style?.borderStyle || 'solid',
    boxSizing: 'border-box',
    ...commonStyles(node.style, isSelected)
  };

  return (
    <div 
      className="report-column"
      style={style}
      onClick={(e) => {
        if (readOnly) return;
        e.stopPropagation();
        onSelect(node.id);
      }}
    >
      {/* Column Label */}
      {isSelected && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          backgroundColor: '#f59e0b', // orange for column
          color: 'white',
          fontSize: '10px',
          padding: '2px 6px',
          zIndex: 10
        }}>
          Column
        </div>
      )}
      
      {renderChildren(node.children)}

      {(!node.children || node.children.length === 0) && isSelected && (
        <div style={{
          padding: '10px',
          border: '1px dashed #ccc',
          borderRadius: '4px',
          backgroundColor: 'rgba(0,0,0,0.02)',
          color: '#888',
          fontSize: '12px',
          textAlign: 'center',
          marginTop: '5px',
          cursor: 'pointer'
        }}>
          Empty Column - Select & Add Element
        </div>
      )}
    </div>
  );
};
